import { ROUTES } from '@/constants';

import { PREVIEW_SIZE } from '../../constants';
import type { PolicyData } from '../PolicySearch/SearchPolicyCard';
import { SearchPolicyCard } from '../PolicySearch/SearchPolicyCard';
import { SearchPolicyCardSkeletonList } from '../PolicySearch/SearchPolicyCardSkeleton';
import { SectionHeader } from './SectionHeader';

export function PolicyPreviewSection({
  keyword,
  items,
  totalCount,
  isLoading,
}: {
  keyword: string;
  items: PolicyData[];
  totalCount: number;
  isLoading: boolean;
}) {
  if (!isLoading && items.length < 1) return null;

  return (
    <section className="flex w-full flex-col">
      <SectionHeader
        title="정책"
        totalCount={totalCount}
        moreHref={ROUTES.SEARCH.withSearchParams({
          searchParams: { q: keyword || undefined, category: 'policy' },
        })}
      />
      {isLoading ? (
        <SearchPolicyCardSkeletonList count={PREVIEW_SIZE} />
      ) : (
        <div className="flex flex-col gap-12 mobile-tablet:gap-0">
          {items.map((policy) => (
            <SearchPolicyCard key={policy.id} policy={policy} />
          ))}
        </div>
      )}
    </section>
  );
}
